module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popups/user-email-verification/user-email-verification.component.html
// module id = ./src/app/components/popups/user-email-verification/user-email-verification.component.html
// module chunks = main